import { DependencyTypes } from "../../constants/dependencyTypes";
import uniqueId from "../../utils/uniqueId";

export default dep => {
  return {
    id: uniqueId(),
    subject: dep.predecessor,
    object: dep.successor,
    dependencyType: dep.addToEnd ? DependencyTypes.FS : DependencyTypes.SS
  };
};
